import {FormSection} from "../../../ui";
import {FieldInput} from "@kroschke/react-ui";
import {
    VdaDocumentDefaultBaseProps,
    VdaDocumentDefaultFormData,
    VdaDocumentDefaultValidation
} from "./VdaDocumentDefaultForm";
import {ReactNode} from "react";

export interface VdaLicensePlateFormData extends VdaDocumentDefaultFormData {
    licensePlate: string
}

export interface VdaLicensePlateValidation extends VdaDocumentDefaultValidation {
    licensePlate?: string
}

export interface VdaLicensePlateFormProps extends VdaDocumentDefaultBaseProps {
    disableLicensePlate: boolean
    validation: VdaLicensePlateValidation,
    value: VdaLicensePlateFormData
    onChange: (value: VdaLicensePlateFormData) => any
    onBlur: () => any
    header: ReactNode
}


export function VdaDocumentLicensePlateForm({
                                       value,
                                       disabled,
                                       disableLicensePlate,
                                       onChange,
                                       onBlur,
                                       validation,
                                       label,
                                        header
                                   }: VdaLicensePlateFormProps) {

    return <FormSection
        label={label}
        header={header}
        children={
            <>
                <div className={"columns"}>
                    <div className={"column is-one-third"}>
                        <FieldInput
                            disabled={true}
                            value={value.vin}
                            label={"Fahrgestellnummer"}
                        />
                    </div>
                    <div className={"column is-one-third"}>
                        <FieldInput
                            disabled={disabled || disableLicensePlate}
                            value={value.licensePlate}
                            label={"Kennzeichen"}
                            onChange={licensePlate => {
                                onChange({
                                    ...value,
                                    licensePlate: licensePlate || ''
                                })
                            }}
                            onBlur={() => !disabled && onBlur()}
                            help={validation.licensePlate}
                            invalid={Boolean(validation.licensePlate)}
                        />
                    </div>
                </div>
                <div className={"columns"}>
                    <div className={"column is-one-third"}>
                        <FieldInput
                            disabled={disabled}
                            label={"Dokumenten-Id"}
                            required={true}
                            help={validation.documentId}
                            invalid={Boolean(validation.documentId)}
                            value={value.documentId}
                            onBlur={() => !disabled && onBlur()}
                            onChange={documentID => {
                                onChange({
                                    ...value,
                                    documentId: documentID
                                })
                            }}
                        />
                    </div>
                    <div className={"column is-one-third"}>
                        <FieldInput
                            disabled={disabled}
                            label={"Position"}
                            required={true}
                            help={validation.position}
                            invalid={Boolean(validation.position)}
                            value={`${value.position}`}
                            onBlur={() => !disabled && onBlur()}
                            onChange={position => {
                                onChange({
                                    ...value,
                                    position: parseInt(position) || 0
                                })
                            }}
                        />
                    </div>
                </div>
            </>
        }
    />
}